export default __webpack_public_path__ + "44a6dcccb69c903528bd788cfa215dda.svg";